//计算字符串长度
String.prototype.lengthCH = function() {
	var len = 0;
	for (var i = 0; i < this.length; i++) {
		if (this.charCodeAt(i) > 255 || this.charCodeAt(i) < 0) len += 2;
		else len++;
	}
	return len;
}
//将字符串拆成字符，并存到数组中
String.prototype.strToChars = function() {
	var chars = new Array();
	for (var i = 0; i < this.length; i++) {
		chars[i] = [this.substr(i, 1), this.isCHS(i)];
	}
	String.prototype.charsArray = chars;
	return chars;
}
//判断某个字符是否是汉字
String.prototype.isCHS = function(i) {
	if (this.charCodeAt(i) > 255 || this.charCodeAt(i) < 0)
		return true;
	else
		return false;
}
//截取字符串（从start字节到end字节）
String.prototype.substringCH = function(start, end) {
	var len = 0;
	var str = "";
	this.strToChars();
	for (var i = 0; i < this.length; i++) {
		if (this.charsArray[i][1])
			len += 2;
		else
			len++;
		if (end < len)
			return str;
		else if (start < len)
			str += this.charsArray[i][0];
	}
	return str;
}
//截取字符串（从start字节截取length个字节）
String.prototype.substrCH = function(start, length) {
	return this.substringCH(start, start + length);
}

function formatTime(time) {
	if (typeof time !== 'number' || time < 0) {
		return time
	}

	var hour = parseInt(time / 3600)
	time = time % 3600
	var minute = parseInt(time / 60)
	time = time % 60
	var second = time

	return ([hour, minute, second]).map(function(n) {
		n = n.toString()
		return n[1] ? n : '0' + n
	}).join(':')
}
// 时间格式 'yyyy-MM-dd hh:mm'
function formatDate(date, format) {
	date = date || new Date()
	var _format = function(number) {
		return (number < 10 ? ('0' + number) : number);
	};
	if (format === 'yyyy-MM-dd') {
		return date.getFullYear() + '-' + _format(date.getMonth() + 1) + '-' + _format(date.getDate());
	} else {
		return date.getFullYear() + '-' + _format(date.getMonth() + 1) + '-' + _format(date.getDate()) + ' ' +
			_format(date.getHours()) + ':' + _format(date.getMinutes());
	}
}

function formatLocation(longitude, latitude) {
	if (typeof longitude === 'string' && typeof latitude === 'string') {
		longitude = parseFloat(longitude)
		latitude = parseFloat(latitude)
	}

	longitude = longitude.toFixed(2)
	latitude = latitude.toFixed(2)

	return {
		longitude: longitude.toString().split('.'),
		latitude: latitude.toString().split('.')
	}
}
var dateUtils = {
	UNITS: {
		'年': 31557600000,
		'月': 2629800000,
		'天': 86400000,
		'小时': 3600000,
		'分钟': 60000,
		'秒': 1000
	},
	humanize: function(milliseconds) {
		var humanize = '';
		for (var key in this.UNITS) {
			if (milliseconds >= this.UNITS[key]) {
				humanize = Math.floor(milliseconds / this.UNITS[key]) + key + '前';
				break;
			}
		}
		return humanize || '刚刚';
	},
	format: function(dateStr) {
		var date = this.parse(dateStr)
		var diff = Date.now() - date.getTime();
		if (diff < this.UNITS['天']) {
			return this.humanize(diff);
		}
		var _format = function(number) {
			return (number < 10 ? ('0' + number) : number);
		};
		return date.getFullYear() + '/' + _format(date.getMonth() + 1) + '/' + _format(date.getDate()) + '-' +
			_format(date.getHours()) + ':' + _format(date.getMinutes());
	},
	parse: function(str) { //将"yyyy-mm-dd HH:MM:ss"格式的字符串，转化为一个Date对象
		var a = str.split(/[^0-9]/);
		return new Date(a[0], a[1] - 1, a[2], a[3], a[4], a[5]);
	}
}

function userData() {
	return getStorage('USERDATA')
}

function getStorage(key) {
	let result = window.localStorage.getItem(key)
	if(result != null){
		result = JSON.parse(result)
	}
	return result
}
function setStorage(key,value) {
	value =  JSON.stringify(value);
	return window.localStorage.setItem(key,value);
}
function removeStorage(key) {
	return window.localStorage.removeItem(key);
}

function loginout() {
	removeStorage('USERDATA')
	removeStorage('token')
	router('/login')
}

// 时长秒转 分种 小时
function secondFormat(second) {
	const untis = {
		'年': 31557600,
		'月': 2629800,
		'天': 86400,
		'小时': 3600,
		'分钟': 60,
		'秒': 1
	}
	var humanize = second;
	for (var key in untis) {
		if (second >= untis[key]) {
			humanize = Math.floor(second / untis[key]) + key;
			break;
		}
	}
	return humanize;
}

function router(url){
	window.location.href=url;
}

module.exports = {
	formatDate: formatDate,
	formatTime: formatTime,
	formatLocation: formatLocation,
	dateUtils: dateUtils,
	userData: userData,
	getStorage: getStorage,
	setStorage: setStorage,
	removeStorage: removeStorage,
	loginout: loginout,
	secondFormat: secondFormat,
	router: router,
}
